import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

export default function LanguageSwitch() {
  const { locale, setLocale, t } = useLanguage();

  return (
    <div className="amgLangSwitch" role="group" aria-label={t("nav.language")}>
      <button
        type="button"
        className={locale === "en" ? "amgLangSwitchBtn is-active" : "amgLangSwitchBtn"}
        onClick={() => setLocale("en")}
        lang="en"
        aria-pressed={locale === "en"}
      >
        EN
      </button>
      <span className="amgLangSwitchSep" aria-hidden="true">
        |
      </span>
      <button
        type="button"
        className={locale === "ar" ? "amgLangSwitchBtn is-active" : "amgLangSwitchBtn"}
        onClick={() => setLocale("ar")}
        lang="ar"
        aria-pressed={locale === "ar"}
      >
        العربية
      </button>
    </div>
  );
}
